import React from "react";
import { BiHeart } from "react-icons/bi";
import { HiOutlineShare } from "react-icons/hi";
import { BiPurchaseTagAlt } from "react-icons/bi";

function NftBid({ profileDetails, type }) {
  return (
    <div className="buyNftSection">
      <div className="nftPageBuy">
        <img src="image 61.png" alt="nft" />
      </div>
      <div className="buyNowDisc">
        <h2>Primate #3728</h2>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="d-flex align-items-center gap-2">
              <img src={profileDetails.profileImg} alt="profile" />
              <div className="d-flex align-items-center">
                <h5>{profileDetails.profileName}</h5>
                <img src="signed 1.png" alt="tick" className="tick ms-1" />
              </div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <div className="heartNft">
              <BiHeart /> <span className="ms-2">5</span>
            </div>
            <div className="heartNft pe-3">
              <HiOutlineShare className="me-2 ms-2" /> Share
            </div>
          </div>
        </div>
        <div className="currentPrice ">
          <div>
            <div>
              <p className="currentPriceTag">Current price</p>
            </div>
            <div className="priceTag">
              <BiPurchaseTagAlt /> 30 ETH
            </div>
          </div>
          <div className="d-flex">
            <button className="bidNowButtton">BID now</button>
            <a className="buyN " href="#">
              buy now
            </a>
          </div>
        </div>

        <div className="topBidsList">
          <h6>top places bid’s</h6>
          <div className="bidsList">
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648.png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>16.43 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (1).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>15 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (2).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>15.49 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (3).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>14.23 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (3).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>14.23 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (3).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>14.23 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (3).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>14.23 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
            <div className="d-flex justify-content-between align-items-center listViewSet">
              <div className="d-flex align-items-center">
                <div className="profileView">
                  <img src="Rectangle 648 (3).png" alt="profile" />
                </div>
                <div className="d-flex priceBids">
                  <h6>14.23 eth</h6>
                  <p>by Art Blocks</p>
                </div>
              </div>
              <div className="timeOfbid">16/09/2022, 21:48</div>
            </div>
            <span className="bidLine"></span>
          </div>
        </div>
        <div className="aboutNft">
          <h6>About primate</h6>
          <p>
            Collection of 10,000 Primates facilitating a seamless adoption of
            the web3 space through community fueled ventures and collaborations.
          </p>
        </div>
        <div className="nftDetails">
          <h6>Details</h6>
          <div className="pt-2">
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p>Mint address</p>
              </div>
              <div className="genratedTokens">
                <p>jhdsdshdsb...7yt</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p> Token address</p>
              </div>
              <div className="genratedTokens">
                <p>3dyijshdsb...fy4</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p> Owner</p>
              </div>
              <div className="genratedTokens">
                <p>nyupishdsb...xh2</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p> Artist Royalties</p>
              </div>
              <div className="genratedTokens">
                <p>7.5%</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p> Transaction fee</p>
              </div>
              <div className="genratedTokens">
                <p>2%</p>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="detailsAdress">
                <p> Listing/Bidding/Cancel</p>
              </div>
              <div className="genratedTokens">
                <p>Free</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NftBid;
